// extracted by mini-css-extract-plugin
module.exports = {"seo-container":"Page_seo-container__t3k0g","seo-wrapper":"Page_seo-wrapper__rdwxp","seo-menu-wrapper":"Page_seo-menu-wrapper__E8pFY"};